function initializeFeaturedVideosCarousel() {
  const emblaNode = document.querySelector(".featured-videos .embla");

  if (!emblaNode) return;

  const dotsNode = document.querySelector(".featured-videos .carousel-dots");
  const prevBtnDesktop = document.querySelector(
    ".featured-videos .embla__controls--desktop .prev-btn"
  );
  const nextBtnDesktop = document.querySelector(
    ".featured-videos .embla__controls--desktop .next-btn"
  );
  const prevBtnMobile = document.querySelector(
    ".featured-videos .embla__controls--mobile .prev-btn"
  );
  const nextBtnMobile = document.querySelector(
    ".featured-videos .embla__controls--mobile .next-btn"
  );
  const options = { loop: false };
  const emblaApi = EmblaCarousel(emblaNode, options);

  const addDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
    if (!dotsNode) return;

    let dotNodes = [];

    const addDotBtnsWithClickHandlers = () => {
      dotsNode.innerHTML = emblaApi
        .scrollSnapList()
        .map(
          () =>
            '<button class="carousel-dot" type="button" aria-label="Go to slide"></button>'
        )
        .join("");

      const scrollTo = (index) => {
        emblaApi.scrollTo(index);
      };

      dotNodes = Array.from(dotsNode.querySelectorAll(".carousel-dot"));
      dotNodes.forEach((dotNode, index) => {
        dotNode.addEventListener("click", () => scrollTo(index), false);
      });
    };

    const toggleDotBtnsActive = () => {
      const previous = emblaApi.previousScrollSnap();
      const selected = emblaApi.selectedScrollSnap();
      dotNodes[previous].classList.remove("carousel-dot--selected");
      dotNodes[selected].classList.add("carousel-dot--selected");
    };

    emblaApi
      .on("init", addDotBtnsWithClickHandlers)
      .on("reInit", addDotBtnsWithClickHandlers)
      .on("init", toggleDotBtnsActive)
      .on("reInit", toggleDotBtnsActive)
      .on("select", toggleDotBtnsActive);

    return () => {
      dotsNode.innerHTML = "";
    };
  };

  const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
    if (!prevBtn || !nextBtn) return;

    const togglePrevNextBtnsState = () => {
      if (emblaApi.canScrollPrev()) {
        prevBtn.removeAttribute("disabled");
        prevBtn.classList.remove("inactive");
      } else {
        prevBtn.setAttribute("disabled", "disabled");
        prevBtn.classList.add("inactive");
      }

      if (emblaApi.canScrollNext()) {
        nextBtn.removeAttribute("disabled");
        nextBtn.classList.remove("inactive");
      } else {
        nextBtn.setAttribute("disabled", "disabled");
        nextBtn.classList.add("inactive");
      }
    };

    const scrollPrev = () => {
      if (emblaApi.canScrollPrev()) {
        emblaApi.scrollPrev();
      }
    };

    const scrollNext = () => {
      if (emblaApi.canScrollNext()) {
        emblaApi.scrollNext();
      }
    };

    prevBtn.addEventListener("click", scrollPrev, false);
    nextBtn.addEventListener("click", scrollNext, false);

    emblaApi
      .on("init", togglePrevNextBtnsState)
      .on("reInit", togglePrevNextBtnsState)
      .on("select", togglePrevNextBtnsState);

    return togglePrevNextBtnsState;
  };

  const addScrollbarHandlers = (emblaApi, scrollbarNode) => {
    if (!scrollbarNode) return;

    const thumbNode = scrollbarNode.querySelector(".embla__scrollbar-thumb");
    if (!thumbNode) return;

    const updateScrollbar = () => {
      const viewportWidth = emblaApi.rootNode().clientWidth;
      const contentWidth = emblaApi.containerNode().scrollWidth;
      const trackWidth = scrollbarNode.clientWidth;
      const thumbWidth = Math.max(
        (viewportWidth / contentWidth) * trackWidth,
        40
      );
      const progress = Math.min(Math.max(emblaApi.scrollProgress(), 0), 1);

      thumbNode.style.width = `${thumbWidth}px`;
      thumbNode.style.transform = `translateX(${
        progress * (trackWidth - thumbWidth)
      }px)`;
    };

    const scrollToPoint = (event) => {
      const rect = scrollbarNode.getBoundingClientRect();
      const point = (event.clientX - rect.left) / rect.width;
      const lastSnap = emblaApi.scrollSnapList().length - 1;
      const index = Math.round(point * lastSnap);
      emblaApi.scrollTo(Math.min(Math.max(index, 0), lastSnap));
    };

    scrollbarNode.addEventListener("click", scrollToPoint, false);

    emblaApi
      .on("reInit", updateScrollbar)
      .on("scroll", updateScrollbar)
      .on("resize", updateScrollbar);

    updateScrollbar();
  };

  addDotBtnsAndClickHandlers(emblaApi, dotsNode);
  addScrollbarHandlers(
    emblaApi,
    document.querySelector(".featured-videos .embla__scrollbar")
  );

  if (prevBtnDesktop && nextBtnDesktop) {
    addPrevNextBtnsClickHandlers(emblaApi, prevBtnDesktop, nextBtnDesktop);
  }
  if (prevBtnMobile && nextBtnMobile) {
    addPrevNextBtnsClickHandlers(emblaApi, prevBtnMobile, nextBtnMobile);
  }
}

// Uses IntersectionObserver (like product-card-carousel.js) instead of Embla's scroll state, since snap points don't always mean "fully visible".
const VISIBILITY_THRESHOLD = 0.6;
// A single threshold leaves other videos' ratios stale between crossings and never reliably reports an exit back to 0; a step list fixes both.
const VISIBILITY_STEPS = Array.from({ length: 11 }, (_, i) => i / 10);

function initializeFeaturedVideosPlayback() {
  const videos = document.querySelectorAll(".featured-videos .featured-video-el");
  if (videos.length === 0) return;

  // IntersectionObserver only reports entries whose ratio crossed a threshold, so this map preserves every other video's last-known ratio.
  const ratios = new Map();
  for (const video of videos) {
    ratios.set(video, 0);
  }

  const updatePlayback = () => {
    let mostVisible = null;
    let highestRatio = 0;

    for (const [video, ratio] of ratios) {
      if (ratio > highestRatio) {
        highestRatio = ratio;
        mostVisible = video;
      }
    }

    for (const [video] of ratios) {
      if (video === mostVisible && highestRatio >= VISIBILITY_THRESHOLD) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
      }
      updatePlayback();
    },
    { threshold: VISIBILITY_STEPS }
  );

  for (const video of videos) {
    observer.observe(video);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initializeFeaturedVideosCarousel();
  initializeFeaturedVideosPlayback();
});
